




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const WEBSITEHOMEPAGEGETBYTOKEN= createAsyncThunk(
  "websitehomepageGetByToken/websitehomepageGetByToken",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const websitehomepageGetByTokenSlice = createSlice({
  name: "websitehomepageGetByTokenSlice",
  initialState: {
    websitehomepageGetByToken: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfwebsitehomepageGetByToken: (state) => {
        state.websitehomepageGetByToken.loading = false
        state.websitehomepageGetByToken.error = false
        state.websitehomepageGetByToken.data = []
        state.websitehomepageGetByToken.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(WEBSITEHOMEPAGEGETBYTOKEN.fulfilled, (state, action) => {
      state.websitehomepageGetByToken = {
        ...state.websitehomepageGetByToken,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(WEBSITEHOMEPAGEGETBYTOKEN.pending, (state, action) => {
      state.websitehomepageGetByToken = {
        ...state.websitehomepageGetByToken,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(WEBSITEHOMEPAGEGETBYTOKEN.rejected, (state, action) => {
      state.websitehomepageGetByToken = {
        ...state.websitehomepageGetByToken,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const websitehomepageGetByTokenAction = {
    WEBSITEHOMEPAGEGETBYTOKEN,
};

export { websitehomepageGetByTokenAction };
export default websitehomepageGetByTokenSlice.reducer;
export const {setInitialStateOfwebsitehomepageGetByToken} = websitehomepageGetByTokenSlice.actions
